module.exports = __webpack_public_path__ + "static/media/confirmation_lifestyle_mobile.33420808.webp";